export const CABIN_INTERIOR = 'INTERIOR';
export const CABIN_OUTSIDE = 'OUTSIDE';
export const CABIN_BALCONY = 'BALCONY';
export const CABIN_DELUXE = 'DELUXE';
export const CABIN_CONCIERGE = 'CONCIERGE';
export const CABIN_AQUA = 'AQUA';

export const testSailings = [
  {
    bookingLink:
      '/booking/landing?groupId=RD07SWD-1775188004&sailDate=2022-05-13&shipCode=RD&packageCode=RD07A220&destinationCode=ALCAN&selectedCurrencyCode=USD',
    id: 'RD07A220_2022-05-13',
    itinerary: {
      code: 'RD07A220',
      __typename: 'Itinerary',
    },
    sailDate: '2022-05-13',
    startDate: '2022-05-13',
    stateroomClassPricing: [
      {
        price: {
          value: 709,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'INTERIOR',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
      {
        price: {
          value: 866,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'OUTSIDE',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
      {
        price: {
          value: 1528.5,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'BALCONY',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
      {
        price: {
          value: 2586.5,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'DELUXE',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
    ],
    __typename: 'Sailing',
  },
  {
    bookingLink:
      '/booking/landing?groupId=RD07SWD-1775188004&sailDate=2022-09-16&shipCode=RD&packageCode=RD07A220&destinationCode=ALCAN&selectedCurrencyCode=USD',
    id: 'RD07A220_2022-09-16',
    itinerary: {
      code: 'RD07A220',
      __typename: 'Itinerary',
    },
    sailDate: '2022-09-16',
    startDate: '2022-09-16',
    stateroomClassPricing: [
      {
        price: {
          value: 479.5,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'INTERIOR',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
      {
        price: {
          value: 669.5,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'OUTSIDE',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
      {
        price: {
          value: 1416,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'BALCONY',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
      {
        price: {
          value: 2508.5,
          __typename: 'Price',
        },
        stateroomClass: {
          id: 'DELUXE',
          __typename: 'StateroomClass',
        },
        __typename: 'StateroomClassPrice',
      },
    ],
    __typename: 'Sailing',
  },
];

export const testLowestSailing = {
  sailings: [
    {
      bookingLink:
        '/booking/landing?groupId=BR04TPA-578713352&sailDate=2023-01-26&shipCode=BR&packageCode=BR4BH124&destinationCode=CARIB&selectedCurrencyCode=USD',
      id: 'BR4BH124_2023-01-26',
      itinerary: {
        code: 'BR4BH124',
        __typename: 'Itinerary',
      },
      sailDate: '2023-01-26',
      startDate: '2023-01-26',
      endDate: '2023-01-31',
      stateroomClassPricing: [
        {
          price: {
            value: 291.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'INTERIOR',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 321.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'OUTSIDE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 483.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'BALCONY',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 758.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'DELUXE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
      ],
      __typename: 'Sailing',
    },
    {
      bookingLink:
        '/booking/landing?groupId=BR04TPA-578713352&sailDate=2023-03-23&shipCode=BR&packageCode=BR4BH124&destinationCode=CARIB&selectedCurrencyCode=USD',
      id: 'BR4BH124_2023-03-23',
      itinerary: {
        code: 'BR4BH124',
        __typename: 'Itinerary',
      },
      sailDate: '2023-03-23',
      startDate: '2023-03-23',
      stateroomClassPricing: [
        {
          price: {
            value: 321.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'INTERIOR',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 361.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'OUTSIDE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 504,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'BALCONY',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 669,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'DELUXE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
      ],
      __typename: 'Sailing',
    },
    {
      bookingLink:
        '/booking/landing?groupId=BR04TPA-578713352&sailDate=2023-04-06&shipCode=BR&packageCode=BR4BH124&destinationCode=CARIB&selectedCurrencyCode=USD',
      id: 'BR4BH124_2023-04-06',
      itinerary: {
        code: 'BR4BH124',
        __typename: 'Itinerary',
      },
      sailDate: '2023-04-06',
      startDate: '2023-04-06',
      stateroomClassPricing: [
        {
          price: {
            value: 391.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'INTERIOR',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 461.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'OUTSIDE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 594,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'BALCONY',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 679,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'DELUXE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
      ],
      __typename: 'Sailing',
    },
    {
      bookingLink:
        '/booking/landing?groupId=BR04TPA-578713352&sailDate=2023-04-20&shipCode=BR&packageCode=BR4BH124&destinationCode=CARIB&selectedCurrencyCode=USD',
      id: 'BR4BH124_2023-04-20',
      itinerary: {
        code: 'BR4BH124',
        __typename: 'Itinerary',
      },
      sailDate: '2023-04-20',
      startDate: '2023-04-20',
      stateroomClassPricing: [
        {
          price: {
            value: 341,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'INTERIOR',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 351.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'OUTSIDE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 513.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'BALCONY',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 728.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'DELUXE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
      ],
      __typename: 'Sailing',
    },
    {
      bookingLink:
        '/booking/landing?groupId=BR04TPA-578713352&sailDate=2023-03-23&shipCode=BR&packageCode=BR4BH124&destinationCode=CARIB&selectedCurrencyCode=USD',
      id: 'BR4BH124_2024-03-23',
      itinerary: {
        code: 'BR4BH124',
        __typename: 'Itinerary',
      },
      sailDate: '2024-03-23',
      startDate: '2023-03-23',
      stateroomClassPricing: [
        {
          price: {
            value: 321.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'INTERIOR',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 321.5,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'OUTSIDE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: null,
          stateroomClass: {
            id: 'BALCONY',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
        {
          price: {
            value: 669,
            __typename: 'Price',
          },
          stateroomClass: {
            id: 'DELUXE',
            __typename: 'StateroomClass',
          },
          __typename: 'StateroomClassPrice',
        },
      ],
      __typename: 'Sailing',
    },
  ],
};
